<template>
	<div class="insideBody">
		<div class="studyReport">
			
			<div class="main" id="capture">
				
				<div class="conTop on clr">
					<div class="export fr" @click="getImg">导出学习报告</div>
				</div>
				
				<div class="data_top">
					<ul>
								<li class="li1">
									<div class="tit">共学单元</div>
									<div class="text"><span>{{danyuans}}</span>个</div>
								</li>
								<li class="li2">
									<div class="tit">总学习时长</div>
									<div class="text"><span>{{zaixiansc}}</span>分钟</div>
								</li>
								<li class="li3">
									<div class="tit">总获得积分</div>
									<div class="text"><span>{{zongjf}}</span>积分</div>
								</li>
							 
							</ul>
				</div>
				
				<div class="data_list">
							<div class="tits">
								学习时间柱状图
							 
								<div class="name_list name_list2 fr">学习时长</div>
							</div>
							<div id="Chart" class="Chart"></div>
						</div>
            <div class="details">
							<div class="data_list">
								<div class="tits">
									音标突击学习详情
								</div>
								<div class="table">
									<el-table
										 
										:data="tableData"
										style="width: 100%">
										<el-table-column
											align="center"
											prop="createtime"
											min-width="80"
											label="日期">
                 
										</el-table-column>
										<el-table-column
											align="center"
											prop="modetype"
											min-width="120"
											label="版块">
										</el-table-column>
										<el-table-column
											align="center"
											prop="unitname"
											min-width="100"
											label="学习单元">
										</el-table-column>
										<el-table-column
											align="center"
											prop="usetime"
											min-width="80"
											label="学习时长">
                     
										</el-table-column>
										 
										<el-table-column
											align="center"
											prop="defen"
											min-width="150"
											label="正确率">
											<template slot-scope="scope">
												{{scope.row.defen}}
												<!-- <span class="btn" @click="checkwrongBlon = true">查看</span>
												<span class="btn">导出</span> -->
											</template>>
										</el-table-column>
										<el-table-column
											align="center"
											prop="jifen"
											min-width="80"
											label="积分">
											<template slot-scope="scope">
												<span class="red">{{scope.row.jifen}}</span>
											</template>>
										</el-table-column>
									</el-table>
								</div>
								 
							</div>
						</div>
			</div>
			
			 
			
			 
			
		</div>
	</div>
</template>
<script>

import domtoimage from 'dom-to-image';
import { getSymbolReport } from "../../api/report";

export default {
  data(){
    return {
      	height: null,
			popupheight: null,
			childheight: null,
			tableData: [],
      checkwrongBlon: false,
      userinfo:this.utils.storageGet("userinfo"),
      danyuans:0,
      zaixiansc:0,
      zongjf:0,
      times:[],
      datas:[]
		};
	},
	created(){
    let that = this;
    getSymbolReport({studentid:that.userinfo.userid}).then((res)=>{
      that.tableData = res.list;
      that.danyuans = res.danyuans;
      that.zaixiansc = res.zaixiansc;
      that.zongjf = res.zongjf;
      that.times = res.times;
      that.datas = res.datas;
      that.Chart();
    });
	},
	methods:{
    getImg() {

      let node = document.getElementById('capture');
      domtoimage.bgcolor = '#ffffff';
     
      domtoimage.toPng(node).then(
        (dataUrl) => {
          let userinfo = this.utils.storageGet("userinfo");
       
          let link = document.createElement("a");
          link.href = dataUrl;//下载链接
          link.setAttribute("download",`${userinfo.username} - 智能音标.png`);
          link.style.display = "none";//a标签隐藏
          document.body.appendChild(link);
          link.click();
        }        
      ).catch(function (error) {
        console.error('oops, something went wrong!', error);
      });

     
    },
		Chart(){
			var that = this,myChart = that.$echarts.init(document.getElementById('Chart'));
			myChart.clear();
			// 绘制图表
			myChart.setOption({
				tooltip: {
					trigger: 'axis',
					axisPointer: { // 坐标轴指示器，坐标轴触发有效
						type: 'shadow'// 默认为直线，可选为：'line' | 'shadow'
					}
				},
				legend: { 
					left:'right',
					top: 0,
					data:[]//['学习时长','有效时长']
				},
				grid: {
					left: 10,
					right: 40,
					bottom: 0,
					containLabel: true
				},
				xAxis: [
					{
						type: 'category',
						name: '日期',
						data: this.times
					}
				],
				yAxis: [
					{
						type: 'value',
						name: '时间/分钟',
					}
				],
				series: [
					{
						name:'学习时长',
						type:'bar',
						stack: '日期',
						color: "#4069fa",
						data: this.datas
					},
				]
			});
		}
	},
	mounted(){
		var that = this;
		that.height = window.innerHeight - (450*that.utils.per());
		
	}
}
</script>
<style scoped>
	
</style>